import { get } from 'lodash-es';

import type { ProductProfile, ProductsState } from './products.types';
import type { RootState } from 'store/root-state';

export const productDetailsProductId = (state: ProductsState): number | undefined => get(state, 'productId');
export const productDetailsIsLoading = (state: ProductsState): boolean | undefined => get(state, 'productDetailsIsLoading');
export const productProfiles = (state: ProductsState): ProductProfile[] | undefined => get(state, 'productProfiles');
export const shouldUseAggregateInventory = (state: ProductsState): boolean | undefined => get(state, 'shouldUseAggregateInventory');
export const productImportStarted = (state: ProductsState): boolean | undefined => get(state, 'importProductsStarted');
export const productImportCompleted = (state: ProductsState): boolean | undefined => get(state, 'importProductsComplete');
export const productExportStarted = (state: ProductsState): boolean | undefined => get(state, 'exportProductsStarted');
export const productExportCompleted = (state: ProductsState): boolean | undefined => get(state, 'exportProductsComplete');

export const selectProductproductDetailsProductId = (state: RootState): number | undefined =>
  productDetailsProductId(get(state, 'products'));
export const selectProductproductDetailsIsLoading = (state: RootState): boolean | undefined =>
  productDetailsIsLoading(get(state, 'products'));
export const selectProductproductProfiles = (state: RootState): ProductProfile[] | undefined => productProfiles(get(state, 'products'));
export const selectProductshouldUseAggregateInventory = (state: RootState): boolean | undefined =>
  shouldUseAggregateInventory(get(state, 'products'));
export const selectProductproductImportStarted = (state: RootState): boolean | undefined => productImportStarted(get(state, 'products'));
export const selectProductproductImportCompleted = (state: RootState): boolean | undefined =>
  productImportCompleted(get(state, 'products'));
export const selectProductproductExportStarted = (state: RootState): boolean | undefined => productExportStarted(get(state, 'products'));
export const selectProductproductExportCompleted = (state: RootState): boolean | undefined =>
  productExportCompleted(get(state, 'products'));
